module.exports = __webpack_public_path__ + "static/img/software.5ecd742.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/software.png
// module id = 8Yhv
// module chunks = 9